/** @jsx jsx */
// eslint-disable-next-line
import React from 'react'
import { css, jsx } from '@emotion/core'
import { Cancel, CheckCircle, RadioButtonUnchecked } from '@material-ui/icons'
import PropTypes from 'prop-types'
import { PasswordPolicy, theme } from '../../../constants'
import { getFittingLength, getPasswordErrors, PasswordRules } from '../../../utils/passwordPolicy'

const styles = {}

styles.list = css`
  display: flex;
  flex-wrap: wrap;
  gap: 0 12px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 0.75rem;
  line-height: 1.66;
`

styles.item = css`
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s;
`

const requirements = [
  PasswordRules.MIN_LENGTH,
  PasswordRules.UPPERCASE,
  PasswordRules.LOWERCASE,
  PasswordRules.NUMBER
]

function PasswordRequirements(props) {
  const errors = getPasswordErrors(props.password)
  return (
    <ul css={styles.list} aria-live="polite">
      {requirements.map(rule => {
        const isMet = !errors.includes(rule)
        return (
          <li
            key={rule}
            css={styles.item}
            style={{ color: isMet ? theme.palette.primary.main : theme.palette.text.disabled }}
          >
            {isMet ? (
              <CheckCircle fontSize="inherit" />
            ) : (
              <RadioButtonUnchecked fontSize="inherit" />
            )}
            {window.I18n.t(`settings.passwordRequirements.${rule}`, {
              count: PasswordPolicy.minLength
            })}
          </li>
        )
      })}
      {/* Tells how many characters fit, as characters like 'ñ' or '中' take several bytes. */}
      {errors.includes(PasswordRules.MAX_LENGTH) && (
        <li css={styles.item} style={{ color: theme.palette.error.light }}>
          <Cancel fontSize="inherit" />
          {window.I18n.t('settings.passwordRequirements.maxLength', {
            count: getFittingLength(props.password)
          })}
        </li>
      )}
    </ul>
  )
}

PasswordRequirements.propTypes = {
  password: PropTypes.string.isRequired
}

export default PasswordRequirements
